<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Perguntas Frequentes (FAQ)</h5>
      <button class="btn btn-sm btn-primary" @click="openNew">
        <i class="bx bx-plus mr-1"></i> Nova Pergunta
      </button>
    </div>

    <p class="text-muted font-size-13 mb-3">
      Cadastre perguntas e respostas sobre o evento. A IA usa essas informacoes para responder automaticamente os participantes via WhatsApp.
    </p>

    <!-- Lista de FAQs -->
    <div v-if="faqs.length === 0" class="text-center text-muted py-4">
      <i class="bx bx-message-square-detail" style="font-size: 40px;"></i>
      <p class="mt-2">Nenhuma pergunta cadastrada ainda.</p>
    </div>

    <div v-else class="faq-list">
      <div v-for="(faq, idx) in faqs" :key="faq.id" class="faq-item" :class="{ inactive: !faq.active }">
        <div class="faq-order">{{ idx + 1 }}</div>
        <div class="faq-content">
          <div class="faq-question">{{ faq.question }}</div>
          <div class="faq-answer">{{ faq.answer }}</div>
          <span v-if="faq.category" class="badge badge-soft-info font-size-11 mt-1">{{ faq.category }}</span>
        </div>
        <div class="faq-actions">
          <button class="btn btn-sm btn-link text-muted p-1" @click="toggleActive(faq)" :title="faq.active ? 'Desativar' : 'Ativar'">
            <i :class="faq.active ? 'bx bx-show' : 'bx bx-hide'"></i>
          </button>
          <button class="btn btn-sm btn-link text-primary p-1" @click="openEdit(faq)" title="Editar">
            <i class="bx bx-edit"></i>
          </button>
          <button class="btn btn-sm btn-link text-danger p-1" @click="remove(faq)" title="Excluir">
            <i class="bx bx-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal criar/editar -->
    <b-modal v-model="showModal" :title="editingFaq ? 'Editar Pergunta' : 'Nova Pergunta'" hide-footer centered>
      <div class="form-group">
        <label>Pergunta</label>
        <input v-model="form.question" type="text" class="form-control" placeholder="Ex: Onde vai ser o evento?" />
      </div>
      <div class="form-group">
        <label>Resposta</label>
        <textarea v-model="form.answer" class="form-control" rows="4" placeholder="Ex: O evento sera no Centro de Convencoes..."></textarea>
      </div>
      <div class="form-group">
        <label>Categoria (opcional)</label>
        <input v-model="form.category" type="text" class="form-control" placeholder="Ex: Local, Horario, Dresscode" />
      </div>
      <div class="d-flex justify-content-end mt-3" style="gap: 8px;">
        <button class="btn btn-light" @click="showModal = false">Cancelar</button>
        <button class="btn btn-primary" @click="save" :disabled="!form.question || !form.answer">
          {{ editingFaq ? 'Salvar' : 'Criar' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getFaqs, createFaq, updateFaq, deleteFaq } from '../services'
import { successMessage, errorMessage } from '@/components/alertsMessages'

export default {
  data () {
    return {
      faqs: [],
      showModal: false,
      editingFaq: null,
      form: { question: '', answer: '', category: '' }
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      try {
        const { data } = await getFaqs()
        this.faqs = data.data || []
      } catch (e) {
        console.error(e)
      }
    },
    openNew () {
      this.editingFaq = null
      this.form = { question: '', answer: '', category: '' }
      this.showModal = true
    },
    openEdit (faq) {
      this.editingFaq = faq
      this.form = { question: faq.question, answer: faq.answer, category: faq.category || '' }
      this.showModal = true
    },
    async save () {
      try {
        if (this.editingFaq) {
          await updateFaq(this.editingFaq.id, this.form)
          successMessage('Pergunta atualizada com sucesso.', 2000)
        } else {
          await createFaq(this.form)
          successMessage('Pergunta criada com sucesso.', 2000)
        }
        this.showModal = false
        this.load()
      } catch (e) {
        errorMessage('Erro ao salvar: ' + (e.response?.data?.message || e.message))
      }
    },
    async remove (faq) {
      if (!confirm('Excluir esta pergunta?')) return
      try {
        await deleteFaq(faq.id)
        successMessage('Pergunta excluida.', 2000)
        this.load()
      } catch (e) {
        errorMessage('Erro ao excluir.')
      }
    },
    async toggleActive (faq) {
      try {
        await updateFaq(faq.id, { active: !faq.active })
        faq.active = !faq.active
      } catch (e) {
        errorMessage('Erro ao atualizar.')
      }
    }
  }
}
</script>

<style scoped>
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: opacity 0.2s;
}

.faq-item.inactive {
  opacity: 0.5;
}

.faq-order {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #666;
  flex-shrink: 0;
  margin-top: 2px;
}

.faq-content {
  flex: 1;
  min-width: 0;
}

.faq-question {
  font-size: 13px;
  font-weight: 600;
  color: #1a1d26;
  margin-bottom: 2px;
}

.faq-answer {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.faq-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
</style>
